import { apiService } from "../../../utils/api/api.service";
import { requestWithErrorHandling } from "../../../utils/error/handle.error";

class TwoFactorService {
  private static instance: TwoFactorService;

  static getInstance(): TwoFactorService {
    if (!TwoFactorService.instance) {
      TwoFactorService.instance = new TwoFactorService();
    }
    return TwoFactorService.instance;
  }

  getStatus = () => {
    return requestWithErrorHandling(async () => {
      return await apiService.get("/two-factor/status");
    });
  };

  enable = (method: 'email' | 'phone', phoneNumber?: string, phoneCode?: string) => {
    return requestWithErrorHandling(async () => {
      return await apiService.post("/two-factor/enable", {
        method,
        phoneNumber,
        phoneCode,
      });
    });
  };

  verifyCode = (code: string) => {
    return requestWithErrorHandling(async () => {
      return await apiService.post("/two-factor/verify", { code });
    });
  };

  disable = () => {
    return requestWithErrorHandling(async () => {
      return await apiService.post("/two-factor/disable", {});
    });
  };

  resendCode = () => {
    return requestWithErrorHandling(async () => {
      return await apiService.post("/two-factor/resend-code", {});
    });
  };

  verifyCredentials = (email: string, password: string) => {
    return requestWithErrorHandling(async () => {
      return await apiService.post("/two-factor/verify-credentials", {
        email,
        password
      });
    });
  };
}

export const twoFactorService = TwoFactorService.getInstance();
